









import { IWikiObject as IWiki, IWikiCategory } from "@/@types/wiki/wiki-object";
import { Component, Prop, Vue } from "vue-property-decorator";

import WikiObjectForm from "@/components/forms/wiki/wiki-object-form.vue";
import StandartModal from "@/components/app/standart-modal.vue";

@Component({
  components: { StandartModal, "wiki-form": WikiObjectForm },
})
export default class ChangeWiki extends Vue {
  @Prop({ type: Object, default: null }) item!: IWiki | null;
  @Prop({ type: Array, default: () => [] }) categorys!: Array<IWikiCategory>;

  change(data: Partial<IWiki>, id: string): void {
    this.$emit("changeWikiObj", data, id);
  }
}
